import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Successfulprojects() {
  return (
    <section className="successful_projects projects_uk projects_dubai p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Browse Our Dubai App Development Services Portfolio</h2>
            <p>
              We've guided startups and enterprises globally to success. Our
              passion and expertise lie in creating top-notch digital solutions,
              empowering companies to excel in their industries. As a leading
              mobile app development company in Dubai, we collaborate with
              entrepreneurs, blending advanced technologies to craft intuitive,
              revolutionary solutions for their ventures and audiences. Explore
              our transformative projects and witness our commitment to
              excellence as top mobile app developers in Dubai, UAE.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1.3,
                },
                1366: {
                  slidesPerView: 1.4,
                },
                1600: {
                  slidesPerView: 1.6,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/locationgcc/dubai_new/mdrouz_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={182}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Multi-vendor e-commerce solution with an emphasis on
                        user-friendly interface
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>60%</h5>
                        <p>Improvement in Productivity</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/mdrouz"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/locationgcc/dubai_new/mdrouz.webp"
                      alt="MD Roudz image"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/locationgcc/dubai_new/yeppy_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={196}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Revolutionizing daily life and offering exclusive
                        services in one platform
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>22%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>30%</h5>
                        <p>Increase in Productivity</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/yeppy"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/locationgcc/dubai_new/yeppy.webp"
                      alt="Tekrevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/locationgcc/dubai_new/equilogo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={75}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Digital platform for horse owners & industry
                        stakeholders to collaborate
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>55%</h5>
                        <p>Improvement in Connections</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/equi-trip"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/locationgcc/dubai_new/equitrip.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/locationgcc/dubai_new/mdrouz_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={182}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Multi-vendor e-commerce solution with an emphasis on
                        user-friendly interface
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>60%</h5>
                        <p>Improvement in Productivity</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/mdrouz"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/locationgcc/dubai_new/mdrouz.webp"
                      alt="MD Roudz image"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/locationgcc/dubai_new/yeppy_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={196}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Revolutionizing daily life and offering exclusive
                        services in one platform
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>22%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>30%</h5>
                        <p>Increase in Productivity</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/yeppy"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/locationgcc/dubai_new/yeppy.webp"
                      alt="Tekrevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/locationgcc/dubai_new/equilogo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={75}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Digital platform for horse owners & industry
                        stakeholders to collaborate
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>55%</h5>
                        <p>Improvement in Connections</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/equi-trip"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/locationgcc/dubai_new/equitrip.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successfulprojects;
